<template>
    <DsDropdown
        position="bottom-end"
        data-qa="decision-diamond-actions-menu-dropdown"
    >
        <template #default>
            <DsIconButton
                data-qa="template-actions-menu-btn"
                class="dropdown-button"
                name="more-vertical"
            />
        </template>

        <template #menu>
            <ul class="dropdown-menu-list">
                <li
                    v-if="showDebugDataDump"
                    class="option dropdown-menu-item"
                    data-qa="debug-decision-diamond-button"
                    @click="$emit('open-dd-debug-modal')"
                >
                    {{ $t('funnel.edit.decision.diamond.button.debug.text') }}
                </li>
                <li
                    class="option dropdown-menu-item"
                    data-qa="test-decision-diamond-button"
                    @click="$emit('open-dd-test-modal')"
                >
                    {{ $t('funnel.edit.decision.diamond.button.test.text') }}
                </li>
            </ul>
        </template>
    </DsDropdown>
</template>

<script>
export default {
    props: {
        showDebugDataDump: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['open-dd-debug-modal', 'open-dd-test-modal'],
};
</script>
